export const connectClientWirelessNodes = [
  {
    id: "81.234.3.14",
    type: "custom",
    position: { x: 295, y: 50 },
    className: "notebook",
    data: { label: "81.234.3.14" },
    dragHandle: "noDrag",
  },
  {
    id: "203.170.31.73",
    type: "custom",
    position: { x: 465, y: 100 },
    className: "notebook",
    data: { label: "203.170.31.73" },
    dragHandle: "noDrag",
  },
  {
    id: "137.217.230.127",
    type: "custom",
    position: { x: 705, y: 190 },
    className: "notebook",
    data: { label: "137.217.230.127" },
    dragHandle: "noDrag",
  },
  {
    id: "196.235.165.181",
    type: "custom",
    position: { x: 705, y: 10 },
    className: "notebook",
    data: { label: "196.235.165.181" },
    dragHandle: "noDrag",
  },
  {
    id: "205.194.8.31",
    type: "custom",
    position: { x: 55, y: 350 },
    className: "notebook",
    data: { label: "205.194.8.31" },
    dragHandle: "noDrag",
  },
  {
    id: "115.214.225.255",
    type: "custom",
    position: { x: 105, y: 250 },
    className: "notebook",
    data: { label: "115.214.225.255" },
    dragHandle: "noDrag",
  },
  {
    id: "243.147.138.149",
    type: "custom",
    position: { x: 505, y: 250 },
    className: "notebook",
    data: { label: "243.147.138.149" },
    dragHandle: "noDrag",
  },
  {
    id: "210.148.47.179",
    type: "custom",
    position: { x: 105, y: 550 },
    className: "notebook",
    data: { label: "210.148.47.179" },
    dragHandle: "noDrag",
  },
  {
    id: "227.36.41.190",
    type: "custom",
    position: { x: 455, y: 550 },
    className: "notebook",
    data: { label: "227.36.41.190" },
    dragHandle: "noDrag",
  },
  {
    id: "177.236.1.155",
    type: "custom",
    position: { x: 635, y: 410 },
    className: "notebook",
    data: { label: "177.236.1.155" },
    dragHandle: "noDrag",
  },
];
